import { z } from "zod";
import { liquidityPositionSchema } from "../schemas/index.js";
export class LiquidityResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /** Per-partner best prices + consensus for every position on a contest. */
    getContestLiquidity(contestId) {
        return this.http.request({
            method: "GET",
            path: `/contests/${encodeURIComponent(contestId)}/liquidity`,
            endpoint: "liquidity.getContestLiquidity",
            dataSchema: z.array(liquidityPositionSchema),
        });
    }
}
//# sourceMappingURL=liquidity.js.map